
 export enum EPerfilCodigo {
    GestorEstadualDesenvolvimento = 1330,
    TecnicoEstadualDesenvolvimento = 1331,
    GestorEstadualHomologacao = 1334,
    TecnicoEstadualHomologacao = 1335,
    GestorEstadualProducao = 1336,
    TecnicoEstadualProducao = 1337,
    AdministradorGeralDesenvolvimento = 1340,
    AdministradorGeralHomologacao = 1339,
    AdministradorGeralProducao = 1341,
    ConsultaImpressaoDesenvolvimento = 1359,
    ConsultaImpressaoHomologacao = 1360,
    ConsultaImpressaoProducao= 1361,
    RecepcaoDesenvolvimento = 1446,
    RecepcaoHomologacao = 1447,
    RecepcaoProducao = 1448,
    TecnicoMunicipalDesenvolvimento = 1509,
    TecnicoMunicipalHomologacao = 1510,
    TecnicoMunicipalProducao = 1511,
}

 const EPerfilDescricao = new Map<string, string>([
    ['GestorEstadualDesenvolvimento', "Gestor Estadual - Desenvolvimento"],
    ['TecnicoEstadualDesenvolvimento', "Técnico Estadual - Desenvolvimento"],
    ['TecnicoMunicipalDesenvolvimento', "Técnico Municipal - Desenvolvimento"],
    ['AdministradorGeralDesenvolvimento', "Administrador Geral - Desenvolvimento"],
    ['ConsultaImpressaoDesenvolvimento',"Consulta e Impressão - Desenvolvimento"],
    ['GestorEstadualHomologacao', "Gestor Estadual - Homologação"],
    ['TecnicoEstadualHomologacao', "Técnico Estadual - Homologação"],
    ['TecnicoMunicipalHomologacao', "Técnico Municipal - Homologação"],
    ['AdministradorGeralHomologacao', "Administrador Geral - Homologação"],
    ['ConsultaImpressaoHomologacao',"Consulta e Impressão - Homologação"],
    ['GestorEstadualProducao', "Gestor Estadual - Produção"],
    ['TecnicoEstadualProducao', "Técnico Estadual - Produção"],
    ['TecnicoMunicipalProducao', "Técnico Municipal - Produção"],
    ['AdministradorGeralProducao', "Administrador Geral - Produção"],
    ['ConsultaImpressaoProducao',"Consulta e Impressão - Produção"],
    ['RecepcaoDesenvolvimento', 'Recepção - Desenvolvimento'],
    ['RecepcaoHomologacao', 'Recepção - Homologação'],
    ['RecepcaoProducao', 'Recepção - Produção'],
]);


const PerfisArray = [
    {
        codigo:EPerfilCodigo['GestorEstadualDesenvolvimento'],
        nome:EPerfilDescricao.get(EPerfilCodigo[1330])
    },
    {
        codigo:EPerfilCodigo['TecnicoEstadualDesenvolvimento'],
        nome:EPerfilDescricao.get(EPerfilCodigo[1331])
    },
    {
        codigo:EPerfilCodigo['TecnicoMunicipalDesenvolvimento'],
        nome:EPerfilDescricao.get(EPerfilCodigo[1509])
    },
    {
        codigo:EPerfilCodigo['ConsultaImpressaoDesenvolvimento'],
        nome:EPerfilDescricao.get(EPerfilCodigo[1359])
    },
    {
        codigo:EPerfilCodigo['AdministradorGeralDesenvolvimento'],
        nome:EPerfilDescricao.get(EPerfilCodigo[1340])
    },
    {
        codigo:EPerfilCodigo['GestorEstadualHomologacao'],
        nome:EPerfilDescricao.get(EPerfilCodigo[1334])
    },
    {
        codigo:EPerfilCodigo['TecnicoEstadualHomologacao'],
        nome:EPerfilDescricao.get(EPerfilCodigo[1335])
    },
    {
        codigo:EPerfilCodigo['TecnicoMunicipalHomologacao'],
        nome:EPerfilDescricao.get(EPerfilCodigo[1510])
    },
    {
        codigo:EPerfilCodigo['AdministradorGeralHomologacao'],
        nome:EPerfilDescricao.get(EPerfilCodigo[1339])
    },
    {
        codigo:EPerfilCodigo['ConsultaImpressaoHomologacao'],
        nome:EPerfilDescricao.get(EPerfilCodigo[1360])
    },
    {
        codigo:EPerfilCodigo['GestorEstadualProducao'],
        nome:EPerfilDescricao.get(EPerfilCodigo[1336])
    },
    {
        codigo:EPerfilCodigo['TecnicoEstadualProducao'],
        nome:EPerfilDescricao.get(EPerfilCodigo[1337])
    },
    {
        codigo:EPerfilCodigo['TecnicoMunicipalProducao'],
        nome:EPerfilDescricao.get(EPerfilCodigo[1511])
    },
    {
        codigo:EPerfilCodigo['AdministradorGeralProducao'],
        nome:EPerfilDescricao.get(EPerfilCodigo[1341])
    },
    {
        codigo:EPerfilCodigo['ConsultaImpressaoProducao'],
        nome:EPerfilDescricao.get(EPerfilCodigo[1361])
    },
    {
        codigo:EPerfilCodigo['RecepcaoDesenvolvimento'],
        nome:EPerfilDescricao.get(EPerfilCodigo[1446])
    },
    {
        codigo:EPerfilCodigo['RecepcaoHomologacao'],
        nome:EPerfilDescricao.get(EPerfilCodigo[1447])
    },
    {
        codigo:EPerfilCodigo['RecepcaoProducao'],
        nome:EPerfilDescricao.get(EPerfilCodigo[1448])
    },
   
]
export default  PerfisArray;
